module.exports = __webpack_public_path__ + "media/images/globe_arrow-c7aea526.svg";